import { isArray } from '@pe-libs/react-components/build/lib/helper';
import useIntlMessage from '@pe-libs/react-components/build/lib/intl/hooks/useIntlMessage';
import { NextPage } from 'next';
import Head from 'next/head';
import { useRouter } from 'next/router';
import React from 'react';
import { getUrlWithoutParameters } from '#helpers/searchUrl';
import { globalSystemInfoRequested, setUserIntl } from '#modules/app/actions';
import { externalRatingCrawlerCountRequested } from '#modules/expertDirectory/actions';
import { convertToPhoneLocale } from '#modules/expertDirectory/components/CreateLead/helper';
import IndustryDirectory from '#modules/expertDirectory/components/IndustryDirectory';
import { wrapper } from '../../store';
import { StateType } from '../../types';
import messages from '../messages';

type Props = {
  state: StateType;
  host?: string;
};

const ExpertDirectoryPage: NextPage<Props> = ({ host }) => {
  const formatMessage = useIntlMessage();
  const { asPath } = useRouter();
  const urlWithoutParameters = getUrlWithoutParameters(asPath, host);

  return (
    <>
      <Head>
        <title>{formatMessage(messages.expertDirectoryIndustriesPageSeoTitle)}</title>
        <meta name="description" content={formatMessage(messages.expertDirectoryIndustriesPageSeoDescription)} />
        <link rel="canonical" href={urlWithoutParameters} />
      </Head>
      <IndustryDirectory />
    </>
  );
};

export const getServerSideProps = wrapper.getServerSideProps((store) => async (context) => {
  const { lang } = context.query;
  const locale = isArray(lang) ? lang[0] : lang;

  if (locale !== 'de-de') {
    return {
      notFound: true,
    };
  }

  await store.dispatch(globalSystemInfoRequested({ contextRequest: context.req }));
  await store.dispatch(externalRatingCrawlerCountRequested({ contextRequest: context.req }));

  store.dispatch(setUserIntl({ locale: convertToPhoneLocale(locale) }));

  return { props: { host: context.req?.headers.host } };
});

export default ExpertDirectoryPage;
